import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import StickyHeader from 'components/StickyHeader'
import Mixin from 'components/common/Mixin'
import Tabs from 'components/common/Tabs'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import { MAIN_CONTENT, FOOTER } from 'constant'
import { Helmet } from 'react-helmet'
import { generateTrustmaryWidgetScript } from 'helpers/generateTrustmaryWidget'

const nonce = window && window.BOT_NONCE

const StoreDetailsPage = ({
  storeNum,
  tabs,
  eventName,
  reviewsTabIndex,
  initialTabIndex,
  reviewsTabVisited,
  placeholders: {
    footer,
    header
  },
  organizedPlaceholders: {
    StoreDetailsTop = [],
    tabs: {
      StoreDeals,
      StoreServices
    } = {}
  } = {},
  onTabChangedCallback,
  storeIdForTrustmary
}) =>
  <React.Fragment>
    <Helmet>
      <script nonce={ nonce } type="text/javascript">
        {generateTrustmaryWidgetScript()}
      </script>
    </Helmet>

    <StickyHeaderWrapper>
      { header }
      <StickyHeader data-printless />
    </StickyHeaderWrapper>
    <Wrapper id={ MAIN_CONTENT } tabIndex="-1" data-max-width data-max-width-padding >
      { StoreDetailsTop }
      <Tabs
        menu={ tabs }
        position={ initialTabIndex }
        tabToActivate={ reviewsTabIndex }
        eventName={ eventName }
        onTabChanged={ onTabChangedCallback } >
        <TabContentWrapper>
          { StoreDeals }
        </TabContentWrapper>
        <TabContentWrapper>
          { StoreServices }
        </TabContentWrapper>
        <TabContentWrapper ratingTab >
          {/* Trustmary reviews widget container */}
          { reviewsTabVisited && (
            <div data-trustmary-widget={ `bqKkyvudM?m=${storeIdForTrustmary}` } />
          )}
        </TabContentWrapper>
      </Tabs>
    </Wrapper>
    <div id={ FOOTER }>
      { footer }
    </div>
  </React.Fragment>

StoreDetailsPage.propTypes = {
  eventName: PropTypes.string,
  initialTabIndex: PropTypes.number,
  onTabChangedCallback: PropTypes.func,
  organizedPlaceholders: PropTypes.shape({
    StoreDetailsTop: PropTypes.arrayOf(PropTypes.shape()),
    tabs: PropTypes.shape({})
  }),
  placeholders: PropTypes.shape({
    footer: PropTypes.arrayOf(PropTypes.shape()),
    header: PropTypes.arrayOf(PropTypes.shape()),
    mainContent: PropTypes.arrayOf(PropTypes.shape())
  }),
  reviewsTabIndex: PropTypes.number,
  reviewsTabVisited: PropTypes.bool,
  storeIdForTrustmary: PropTypes.string,
  storeNum: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape())
}

export default StoreDetailsPage

const Wrapper = styled.main`
  margin: 0 auto;
  ${Mixin.responsive('padding-top', '10px', '5px')}
  ${Mixin.responsive('padding-bottom', '30px', '10px')}
`

const TabContentWrapper = styled.div`
  ${Mixin.responsive('padding', '50px 0', '30px 12px')}
  ${(props => props.ratingTab && css`
    padding: 0;
  `)}
`
